
const ALL_SLOTS = ['7-11', '11-15', '15-19', '19-23'];

export const mapDataForClient = (bookings) => {
  if (!bookings || !Array.isArray(bookings)) {
    return {
      filteredBookings: [],
      fullyBookedDates: [],
      bookedSlotsByDate: {},
    };
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  // Filter to only include bookings from today onwards
  const filteredBookings = bookings.filter((booking) => {
    if (!booking?.date) return false;
    const bookingDate = new Date(booking.date);
    bookingDate.setHours(0, 0, 0, 0);
    return bookingDate >= today;
  });

  // Group slots by date
  const bookedSlotsByDate = {};
  filteredBookings.forEach((booking) => {
    const { date, slot } = booking;
    if (!bookedSlotsByDate[date]) {
      bookedSlotsByDate[date] = [];
    }
    if (slot && !bookedSlotsByDate[date].includes(slot)) {
      bookedSlotsByDate[date].push(slot);
    }
  });

  // Find dates where all slots are booked
  const fullyBookedDates = Object.entries(bookedSlotsByDate)
    .filter(([, slots]) => ALL_SLOTS.every((slot) => slots.includes(slot)))
    .map(([date]) => new Date(date));

  return {
    filteredBookings,
    fullyBookedDates,
    bookedSlotsByDate,
  };
};

/**
 * Check if a specific slot is booked for a given date
 * @param {Object} bookedSlotsByDate - Map of date -> booked slots
 * @param {Date|string} date - The date to check
 * @param {string} slot - The slot to check (e.g., "7-11", "11-15")
 * @returns {boolean} - true if the slot is booked
 */
export const isSlotBooked = (bookedSlotsByDate, date, slot) => {
  if (!bookedSlotsByDate || !date || !slot) return false;
  
  const dateStr = typeof date === 'string' 
    ? date 
    : date.toISOString().split('T')[0];
  
  const bookedSlots = bookedSlotsByDate[dateStr];
  return bookedSlots ? bookedSlots.includes(slot) : false;
};

/**
 * Convert schedule from/to times to slot format for comparison
 * @param {string} from - Start time (e.g., "07.00")
 * @param {string} to - End time (e.g., "11.00")
 * @returns {string} - Slot format (e.g., "7-11")
 */
export const scheduleToSlotFormat = (from, to) => {
  const fromHour = parseInt(from?.split('.')[0], 10);
  const toHour = parseInt(to?.split('.')[0], 10);
  return `${fromHour}-${toHour}`;
};
